import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getEquipmentDocuments(companyId, equipmentId) {
	return dataTransferWrap(
		ModulesMap.EQUIPMENT_DOCUMENTS,dtConfig[ModulesMap.EQUIPMENT_DOCUMENTS].getEquipmentDocuments, {
		urlParams: {
			companyId,
			equipmentId,
		},
	})
}
function getEquipmentDocument(companyId, equipmentId, documentId) {
	return dataTransferWrap(
		ModulesMap.EQUIPMENT_DOCUMENTS,dtConfig[ModulesMap.EQUIPMENT_DOCUMENTS].getEquipmentDocument, {
		urlParams: {
			companyId,
			equipmentId,
            documentId,
		},
	})
}

function createEquipmentDocument(companyId, equipmentId, data) {
	return dataTransferWrap(
		ModulesMap.EQUIPMENT_DOCUMENTS,dtConfig[ModulesMap.EQUIPMENT_DOCUMENTS].createEquipmentDocument, {
		urlParams: {
			companyId,
            equipmentId,
		},
		...data,
	})
}

function patchEquipmentDocument(companyId, equipmentId, documentId, data) {
	return dataTransferWrap(
		ModulesMap.EQUIPMENT_DOCUMENTS,dtConfig[ModulesMap.EQUIPMENT_DOCUMENTS].patchEquipmentDocument, {
		urlParams: {
			companyId,
			equipmentId,
            documentId,
		},
		...data,
	})
}

function putEquipmentDocument(companyId, equipmentId, documentId, data) {
	return dataTransferWrap(
		ModulesMap.EQUIPMENT_DOCUMENTS,dtConfig[ModulesMap.EQUIPMENT_DOCUMENTS].putEquipmentDocument, {
		urlParams: {
			companyId,
			equipmentId,
            documentId,
		},
		...data,
	})
}

function deleteEquipmentDocument(companyId, equipmentId, documentId) {
	return dataTransferWrap(
		ModulesMap.EQUIPMENT_DOCUMENTS,dtConfig[ModulesMap.EQUIPMENT_DOCUMENTS].deleteEquipmentDocument, {
		urlParams: {
			companyId,
			equipmentId,
            documentId,
		},
	})
}

export default {
    getEquipmentDocuments,
    getEquipmentDocument,
    createEquipmentDocument,
    patchEquipmentDocument,
    putEquipmentDocument,
    deleteEquipmentDocument,
}
